export const PERFORMS = 'performs';
export const CONTRIBUTES = 'contributes';
export const TYPICALLY = 'typically';
export const ATYPICALLY = 'atypically';
export const VACATES_AREA = 'vacates_area';

export const Responsibility = function(minimumPerformers) {
  this.minimumPerformers = minimumPerformers;
  this.performs = {
    typically: 0,
    atypically: 0
  };
  this.contributes = {
    typically: 0,
    atypically: 0
  };
}

Responsibility.prototype.addContribution = function(performance) {
  if (performance.performs === false) return;
  this[performance.performs][performance.atypically ? ATYPICALLY : TYPICALLY]++;
}

Responsibility.prototype.isPerformed = function() {
  if (this.performs.typically >= this.minimumPerformers) {
    return {
      performed: true,
      caveats: false
    };
  }

  if (this.performs.typically + Math.floor(this.contributes.typically / 2) >= this.minimumPerformers) {
    return {
      performed: true,
      caveats: false
    };
  }

  if (this.performs.typically + Math.floor(this.contributes.typically / 2) + this.performs.atypically >= this.minimumPerformers) {
    let atypicalPerformers = this.minimumPerformers - this.performs.typically - this.contributes.atypically / 2;
    return {
      performed: true,
      caveats: [
        { performance: PERFORMS, caveat: ATYPICALLY, count: Math.ceil(atypicalPerformers)}
      ]
    };
  }

  if (this.performs.typically + Math.floor(this.contributes.typically / 2) + this.performs.atypically + this.contributes.atypically / 2 >= this.minimumPerformers) {
    let atypicalPerformers = Math.min(this.performs.atypically, this.minimumPerformers - this.performs.typically - Math.floor(this.contributes.typically / 2));
    let atypicalContributers = (this.minimumPerformers - this.performs.typically - atypicalPerformers - Math.floor(this.contributes.typically / 2)) * 2;
    return {
      performed: true,
      caveats: [
        { performance: PERFORMS, caveat: ATYPICALLY, count: atypicalPerformers },
        { performance: CONTRIBUTES, caveat: ATYPICALLY, count: Math.ceil(atypicalContributers) }
      ]
    };
  }

  return {
    performed: false,
    caveat: false
  };
}

export const Performance = function(performs, contributes, atypically) {
  this.performs = (performs ? PERFORMS : (contributes ? CONTRIBUTES : false));
  this.atypically = atypically;
}
